module.exports = __webpack_public_path__ + "static/media/notificare-Nissan-2.48480ebc.pdf";